module.exports = __webpack_public_path__ + "img/Ptuapp11.11bdc66e.png";